const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-35ca16c0-f82d-4f28-8c97-a00616da217c, .uuid-5f2e3513-096a-492f-8d19-1a2a6fbfc84c {\n        stroke-linecap: round;\n      }\n\n      .uuid-35ca16c0-f82d-4f28-8c97-a00616da217c, .uuid-5f2e3513-096a-492f-8d19-1a2a6fbfc84c, .uuid-d2aa7ea0-5bd4-4bb3-bb4a-7b1074501b4d, .uuid-c681bbec-a4c1-49cd-a3ff-3c26e1aaa702 {\n        fill: none;\n        stroke: #e8e4db;\n        stroke-linejoin: round;\n      }\n\n      .uuid-35ca16c0-f82d-4f28-8c97-a00616da217c, .uuid-c681bbec-a4c1-49cd-a3ff-3c26e1aaa702 {\n        stroke-width: 2px;\n      }\n\n      .uuid-83fa7621-2e98-4c61-affe-496ad8d49339 {\n        fill: #5e3524;\n      }\n    "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-6d345105-a14f-4fcf-8195-0cc4cfa07b66",
  "data-name": "Circles"
}, /*#__PURE__*/React.createElement("circle", {
  className: "uuid-83fa7621-2e98-4c61-affe-496ad8d49339",
  cx: 22,
  cy: 21.95,
  r: 22
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-a2fcea26-8117-469f-a644-5c3bffd7c283",
  "data-name": "Template"
}, /*#__PURE__*/React.createElement("rect", {
  className: "uuid-d2aa7ea0-5bd4-4bb3-bb4a-7b1074501b4d",
  x: 22,
  y: 6.24,
  width: 3.62,
  height: 2.72
}), /*#__PURE__*/React.createElement("rect", {
  className: "uuid-d2aa7ea0-5bd4-4bb3-bb4a-7b1074501b4d",
  x: 30.12,
  y: 26.77,
  width: 5.09,
  height: 8.13
}), /*#__PURE__*/React.createElement("rect", {
  className: "uuid-d2aa7ea0-5bd4-4bb3-bb4a-7b1074501b4d",
  x: 8.78,
  y: 26.77,
  width: 5.09,
  height: 8.13
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-d2aa7ea0-5bd4-4bb3-bb4a-7b1074501b4d",
  d: "M26.51,34.9v-6.32c0-1.49-1.22-2.71-2.72-2.71h-3.61c-1.5,0-2.72,1.22-2.72,2.71v6.32"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "uuid-c681bbec-a4c1-49cd-a3ff-3c26e1aaa702",
  points: "17.48 34.9 13.87 34.9 13.87 20.45 30.12 20.45 30.12 34.9 26.51 34.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-c681bbec-a4c1-49cd-a3ff-3c26e1aaa702",
  d: "M33.88,13.18v7.32H10.12v-7.32h3.75v2.72c0,.24.09.46.26.64.17.17.4.26.64.26h4.52c.24,0,.46-.09.64-.26.17-.18.26-.4.26-.64v-2.72h3.61v2.72c0,.24.09.46.26.64.18.17.4.26.64.26h4.52c.24,0,.47-.09.64-.26.17-.18.26-.4.26-.64v-2.72h3.75Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-35ca16c0-f82d-4f28-8c97-a00616da217c",
  x1: 7.49,
  y1: 34.9,
  x2: 36.5,
  y2: 34.9
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-5f2e3513-096a-492f-8d19-1a2a6fbfc84c",
  x1: 6.93,
  y1: 26.77,
  x2: 13.87,
  y2: 26.77
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-5f2e3513-096a-492f-8d19-1a2a6fbfc84c",
  x1: 30.12,
  y1: 26.77,
  x2: 37.06,
  y2: 26.77
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-5f2e3513-096a-492f-8d19-1a2a6fbfc84c",
  x1: 22,
  y1: 6.24,
  x2: 22,
  y2: 13.18
}));
function SvgRepozeIconCategoryToys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepozeIconCategoryToys);
export default __webpack_public_path__ + "static/media/repoze_icon_category-toys.86c2504a78dfe52fbd17cdc34ff57bd0.svg";
export { ForwardRef as ReactComponent };